import PropTypes from "prop-types";
import styles from "./styles";
import global from "../../styles";

const DrawUnavailable = ({ title, message }) => (
  <div className={styles.wrapper}>
    <h1 className={global.barnsley1}>{title}</h1>
    <p className={global.london1}>{message}</p>
  </div>
);

DrawUnavailable.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default DrawUnavailable;
